module.exports = __webpack_public_path__ + "assets/img/07d270bf6da16ebb4626ccead6ee7108.webp";